import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-resourceadjustments',
  templateUrl: './resourceadjustments.component.html',
  styleUrls: ['./resourceadjustments.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ResourceadjustmentsComponent {

}
